<h1 class="title-modal-add-user" mat-dialog-title>
  <strong>Run a Script</strong>
  <mat-icon (click)="onClose(false)">close</mat-icon>
</h1>
<mat-divider class="divider"></mat-divider>
<form [formGroup]="runScript" (ngSubmit)="onSubmit()">
  <mat-form-field fxFill appearance="fill">
    <mat-label>Name</mat-label>
    <input matInput id="name" formControlName="name" type="text" placeholder="Enter the name" />
  </mat-form-field>

  <div micScrollBar class="sqlQuery">
    <mat-form-field fxFill appearance="fill">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description" placeholder="Ce Script ..."></textarea>
    </mat-form-field>
  </div>
  <mat-form-field fxFill appearance="fill">
    <mat-label>Path</mat-label>
    <input matInput id="path" formControlName="path" type="text" placeholder="Enter the path" />
  </mat-form-field>
  <mat-form-field fxFill appearance="fill">
    <mat-label>FileName</mat-label>
    <input matInput id="fileName" formControlName="fileName" type="text" placeholder="Enter the fileName" />
  </mat-form-field>
  <mat-divider class="divider"></mat-divider>
  <div class="btn-container">
    <button type="submit" mat-raised-button color="primary" [disabled]="!runScript.valid">Submit</button>
  </div>
</form>
